import React from 'react';
import { CollectionTemplate } from '../../templates/collection-template';
export const ProductListRenderer = (props) => {
   // TODO: dont use collectionTemplate, this is meant for page query only.
   // it redefines providers and cant be unstable
   // return <CollectionTemplate {...props} />;
   return null;
};
export default CollectionTemplate;
